import { render, staticRenderFns } from "./breatheManager.vue?vue&type=template&id=475b7646&scoped=true&"
import script from "./breatheManager.vue?vue&type=script&lang=js&"
export * from "./breatheManager.vue?vue&type=script&lang=js&"
import style0 from "./breatheManager.vue?vue&type=style&index=0&id=475b7646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475b7646",
  null
  
)

export default component.exports